// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/halteklammer/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteHalteklammerDE: PageEntry = {
  id: "example.produkte-halteklammer",
  locale: "de",
  slug: "produkte/halteklammer",
  seo: {
    title: "Halteklammer in der Fahrzeugtechnik | Dietz GmbH",
    description: "Komplexe Biegegeometrien in einem Bauteil. An unserer CNC gesteuerten Fertigungsmaschine wurden die komplexen Geometrien umgesetzt. Mit geringen Werkzeugkosten und dem Know How uns",
  },
  type: "post",
  h1: "Halteklammer in der Fahrzeugtechnik",
  intro: "Komplexe Biegegeometrien in einem Bauteil. An unserer CNC gesteuerten Fertigungsmaschine wurden die komplexen Geometrien umgesetzt. Mit geringen Werkzeugkosten und dem Know How unserer Mitarbeiter, konnte so das Bauteil hergestellt werden",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_drahtbiegeteile_t.jpg", alt: "Drahtbiegeteile von DIETZ", width: 1280, height: 1024 }
  ],
};
